// removed by extract-text-webpack-plugin
module.exports = {"arrowBtn":"gv_gw _1kB_d9laDuyaX1azPOvneD","arrowBtnPrev":"gv_gx gv_gw _1kB_d9laDuyaX1azPOvneD","arrowBtnNext":"gv_gy gv_gw _1kB_d9laDuyaX1azPOvneD","arrowBtnDisabled":"gv_gz gv_gw _1kB_d9laDuyaX1azPOvneD","arrow":"gv_g0"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/Carousel/components/Arrow/styles.module.css
// module id = 1217
// module chunks = 27